import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';

import styles from './index.module.scss';

const Forbidden = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.forbiddenPage}>
            <h1 className={styles.title}>
                403
            </h1>
            <div className={styles.description}>
                Sorry, you are not authorized to access this page.
            </div>
            <Button onClick={() => navigate(-1)} className={styles.btnBack} type="primary" size="large">Go Back</Button>
        </div>
    );
}

export default Forbidden;